import Player from "@vimeo/player";

const initVideoOverlays = (sections) => {
    const overlay = document.querySelector(".js-overlay");
    const videoTitleEl = overlay.querySelector(".js-video-title");
    const videoRuntimeEl = overlay.querySelector(".js-runtime");
    const overlayContainer = overlay.querySelector(".js-overlay-container");
    const iframe = overlay.querySelector(".js-video-iframe");

    const pauseButton = overlay.querySelector(".js-pause");
    const muteButton = overlay.querySelector(".js-mute");
    const closeButton = overlay.querySelector(".js-close");
    const progress = overlay.querySelector(".js-progress");
    const currentTimeTarget = overlay.querySelector(".js-current-time");

    let player = null;
    let isPlaying = false;
    let isMuted = false;
    let uiTimeout;

    // Reuseable progress function
    const updateProgress = (value) => {
        progress.style.setProperty("--progress", `${value}%`);
    };

    // Reusable formatting time function
    const formatTime = (time) => {
        const mins = Math.floor(time / 60);
        const secs = Math.floor(time % 60);
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    // Reusable close overlay function
    const closeOverlay = () => {
        overlay.classList.remove("is-active");
        overlay.classList.remove("show-ui");
        updateProgress(0);
        if (player) player.pause();
    };

    // Pause logic
    pauseButton.addEventListener("click", () => {
        if (!player) return;

        isPlaying ? player.pause() : player.play();
    });

    muteButton.addEventListener("click", () => {
        if (!player) return;
        isMuted = !isMuted;
        player.setMuted(isMuted);
        muteButton.classList.toggle("is-animating", !isMuted && isPlaying);
    });

    progress.addEventListener("click", async (e) => {
        if (!player) return;
        const rect = progress.getBoundingClientRect();
        const ratio = Math.min(
            Math.max((e.clientX - rect.left) / rect.width, 0),
            1,
        );
        const duration = await player.getDuration();
        player.setCurrentTime(duration * ratio);
        player.play();
    });

    closeButton.addEventListener("click", closeOverlay);

    // Logic for show/hiding UI
    const showUI = () => {
        clearTimeout(uiTimeout);
        overlay.classList.add("show-ui");
        if (isPlaying) {
            uiTimeout = setTimeout(
                () => overlay.classList.remove("show-ui"),
                5000,
            );
        }
    };

    overlayContainer.addEventListener("mousemove", showUI);

    sections.forEach((section) => {
        const triggers = section.querySelectorAll(".js-overlay-trigger");

        // Toggle overlay logic
        triggers.forEach((trigger) => {
            trigger.addEventListener("click", async () => {
                const { id, title, runtime } = trigger.dataset;

                videoTitleEl.innerText = title;
                videoRuntimeEl.innerText = `/ ${runtime} mins`;
                overlay.classList.add("is-active");

                if (!player) {
                    player = new Player(iframe, {
                        id,
                        autoplay: true,
                        controls: false,
                        transparent: false,
                        muted: true, // satisfy mobile autoplay policy
                    });

                    setupPlayerEvents();

                    await player.ready();
                    await player.play();
                    await player.setVolume(1); // unmute after play starts
                } else {
                    await player.loadVideo(id);
                    await player.setMuted(true);
                    await player.play();
                    await player.setMuted(false);
                }
            });
        });

        function setupPlayerEvents() {
            player.on("play", () => {
                isPlaying = true;
                overlay.classList.add("is-playing");
                muteButton.classList.toggle("is-animating", !isMuted);
                showUI();
            });

            player.on("pause", () => {
                isPlaying = false;
                overlay.classList.remove("is-playing");
                overlay.classList.add("show-ui");
                muteButton.classList.remove("is-animating");
                clearTimeout(uiTimeout);
            });

            player.on("timeupdate", (data) => {
                updateProgress(data.percent * 100);
                currentTimeTarget.innerText = formatTime(data.seconds);
            });
        }
    });
};

export default initVideoOverlays;
